import { render, staticRenderFns } from "./clientArray.vue?vue&type=template&id=5be8f040&scoped=true&"
import script from "./clientArray.vue?vue&type=script&lang=js&"
export * from "./clientArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8f040",
  null
  
)

export default component.exports